import React,{ ReactNode,useState } from 'react';
import SideBar from '../../Components/SideBarNavigation/SideBar';
import TopNavbar from '../../Components/Header/TopNavbar';

interface Props {
    children: ReactNode;
}
export const AuthorizedLayout = (props: Props) => {
    const { children } = props;
    const [openMenu,setOpenMenu] = useState<boolean>(false);

    return (
        <div className='app-background-color'>
            {/* <SideBar openMenu={openMenu} setOpenMenu={setOpenMenu} /> */}
            <TopNavbar setOpenMenu={() => setOpenMenu((prev) => !prev)} openMenu={openMenu}/>
            <div className="d-flex">

            <SideBar openMenu={openMenu} setOpenMenu={() => setOpenMenu((prev) => !prev)}/>
                        
            {/* <Header openMenu={openMenu} setOpenMenu={setOpenMenu} /> */}
            {/* <div className="container">
                {children}
            </div>
            <Footer openMenu={openMenu} setOpenMenu={setOpenMenu} />
             */}
            <div className='container-fluid'>
                {children}
            </div>
            </div>
        </div>
    );
};
